module.exports = __webpack_public_path__ + "static/media/SangBleuVersailles-Regular-WebM.4f94beb7.woff2";